
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              {/* Logo Icon */}
              <div className="relative w-10 h-10 bg-gradient-to-br from-blue-500 to-purple-500 rounded-lg flex items-center justify-center">
                <div className="text-white font-bold text-lg">W</div>
                <div className="absolute -top-1 -right-1 w-4 h-4 bg-gradient-to-br from-purple-400 to-blue-400 rounded-full flex items-center justify-center">
                  <div className="text-white font-bold text-xs">C</div>
                </div>
              </div>
              {/* Logo Text */}
              <h3 className="text-2xl font-bold text-white" style={{ fontFamily: 'Poppins, sans-serif' }}>
                webcoll
              </h3>
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              Her işin webde bir hikayesi var. Webcoll ile markanızın dijital hikayesini yaratın.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-blue-600 rounded-full hover:bg-blue-700 transition-colors cursor-pointer">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-blue-400 rounded-full hover:bg-blue-500 transition-colors cursor-pointer">
                <i className="ri-twitter-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-pink-600 rounded-full hover:bg-pink-700 transition-colors cursor-pointer">
                <i className="ri-instagram-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-blue-700 rounded-full hover:bg-blue-800 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4 text-white">Hızlı Linkler</h4>
            <ul className="space-y-2">
              <li><Link to="/neden-webcoll" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Neden Webcoll?</Link></li>
              <li><Link to="/paketler" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Paketler</Link></li>
              <li><Link to="/blog" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Blog</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4 text-white">İletişim</h4>
            <ul className="space-y-2 text-gray-300">
              <li className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                0545 148 59 52
              </li>
              <li className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                info@webcoll.com
              </li>
              <li className="flex items-center">
                <i className="ri-map-pin-line mr-2"></i>
                İstanbul, Türkiye
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 Webcoll. Tüm hakları saklıdır.
          </p>
          <div className="flex items-center space-x-4 mt-4 md:mt-0">
            <span className="text-gray-400 text-sm">Webcoll — Dijital dünyada görün, fark yaratın.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
